var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLedgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_559",
    "data-name": "Group 559",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M8.451,2A6.451,6.451,0,1,1,2,8.451,6.453,6.453,0,0,1,8.451,2Zm2.281,3.258L7.539,8.451l.912.912L11.644,6.17l-.912-.912Z",
    transform: "translate(-0.71 -0.71)",
    fill: "#f5c839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLedgerIcon);
export default __webpack_public_path__ + "static/media/activeLedgerIcon.ac8996dd995115b4aec83beba25c9ae1.svg";
export { ForwardRef as ReactComponent };